/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVulnerabilityDetailsByTenant {
    getFixupPrototypeFunction() { return AppSecopsSbomVulnerabilityDetailsByTenant.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVulnerabilityDetailsByTenant>): AppSecopsSbomVulnerabilityDetailsByTenant {
        let obj = Object.assign(new AppSecopsSbomVulnerabilityDetailsByTenant(), model);
        AppSecopsSbomVulnerabilityDetailsByTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVulnerabilityDetailsByTenant>): AppSecopsSbomVulnerabilityDetailsByTenant {
        if (!model) return null;
        return AppSecopsSbomVulnerabilityDetailsByTenant.newInstance(<AppSecopsSbomVulnerabilityDetailsByTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVulnerabilityDetailsByTenant) {
        if (!obj) return;

        models.AppSecopsSbomVulnerabilityDetailsByTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVulnerabilityDetailsByTenant): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVulnerabilityDetailsByTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.cvss_metrics) {
            models.AppSecopsVulnerabilityCvssMetric.fixupPrototype(this.cvss_metrics);
        }
        if (this.sbom_source_details) {
            models.AppSecopsVulnerabilitySourceDetails.fixupPrototype(this.sbom_source_details);
        }
    }

    /**
     * CVSS metrics associated with the vulnerability captured from different source.
     */
    cvss_metrics: models.AppSecopsVulnerabilityCvssMetric;

    /**
     * SBOM vulnerability source details specific to the tenant
     */
    sbom_source_details: models.AppSecopsVulnerabilitySourceDetails;

    /**
     * Datetime when the vulnerability details were last updated for the tenant
     */
    updated_at: Date;

}
